import { schema } from "normalizr";

export class EcommerceSchema extends schema.Entity {
  constructor(category?: schema.Entity) {
    super("ecommerce", {
      category
    }, { idAttribute: "_id" });
  }
}
